import { ConstructionSystemApi } from '@/service/api'

class ConstructionSystemRepository {


  public async getPossibleSystemSteps () {
    return await constructionSystemApi.getPossibleSystemSteps()
      .then((response) => {
        return response.data

      })
  }

  public async getDataUsageColumns (siteId: number, siteTaskId: string | undefined) {
    return await constructionSystemApi.getDataUsageColumns(siteId, siteTaskId)
      .then((response) => {
        return response.data
      })
  }

  public async getSystemsForSite (siteId: number) {
    return await constructionSystemApi.getSystemIdsForSite(siteId)
      .then((response) => {
        return response.data
      })
  }
}

const constructionSystemApi = new ConstructionSystemApi()
const constructionSystemRepository = new ConstructionSystemRepository()
export default constructionSystemRepository
